import type { WalletInfo, WalletType } from '../Constants';
import type { Namespace } from '@hub3js/namespaces';
import type { WidgetConfig } from '@rango-dev/widget-embedded';
import type { BlockchainMeta } from 'rango-types';

/*
 * Inlined from the (deprecated) `@rango-dev/ui` flag-icon prop type so this module
 * no longer depends on the legacy UI package.
 */
export type FlagPropTypes = {
  size?: number;
};

export enum BackgroundTypes {
  Light = 0,
  Dark = 1,
}

export enum ExperimentalFeatureName {
  BEST_ROUTE = 'experimental',
  BASE_URL = 'apiUrl',
  API_KEY = 'apiKey',
  AVOID_NATIVE_FEE = 'avoidNativeFee',
  AFFILIATE_PERCENT = 'affiliatePercent',
  AFFILIATE_TOKEN = 'affiliateToken',
  CENTRALIZED_SWAPPERS = 'enableCentralizedSwappers',
  MAX_LENGTH = 'MaxLength',
}

export type ExperimentalEnvironment = 'next' | 'production';

interface BaseExperimentalFeature {
  name: ExperimentalFeatureName;
  displayName: string;
  availableOn: Array<ExperimentalEnvironment>;
}

export interface SwitchExperimentalFeature extends BaseExperimentalFeature {
  type: 'switch';
  enable: boolean;
}

export interface TextFieldExperimentalFeature extends BaseExperimentalFeature {
  type: 'text-field';
  value: string;
  needsReloadTheApp?: boolean;
}

export type ExperimentalFeature = SwitchExperimentalFeature | TextFieldExperimentalFeature;

export type LanguageType = {
  title: string;
  englishTitle: string;
  value: WidgetConfig['language'];
  Icon: React.ComponentType<FlagPropTypes>;
};

export interface Wallet {
  type: WalletType;
  extensionAvailable: boolean;
  connected: boolean;
  info: {
    name: string;
    img: string;
    showOnMobile?: boolean;
    installLink: WalletInfo['installLink'];
    supportedChains: BlockchainMeta[];
    namespaces?: Namespace[];
    singleNamespace?: boolean;
  };
}

export interface RequestedAccount {
  address: string;
  blockchain: string;
}
